import { motion } from 'framer-motion';
import { Phone, MapPin, Clock, Building2 } from 'lucide-react';
import { FOOTER } from '@/constants/testIds';

export const Footer = () => {
	const year = new Date().getFullYear();
	return (
		<footer
			data-testid={FOOTER.root}
			className="bg-brand-navy text-white overflow-hidden"
		>
			<div className="mx-auto max-w-[1400px] px-4 sm:px-8 pt-20 sm:pt-28 pb-10">
				{/* Massive tel */}
				<div className="border-b border-white/15 pb-14 sm:pb-20">
					<div className="font-chivo text-xs uppercase tracking-[0.3em] text-brand-red font-bold mb-6">
						/ One Number — Any Emergency
					</div>
					<motion.a
						href="tel:+13072224082"
						data-testid={FOOTER.callLink}
						initial={{ opacity: 0, y: 30 }}
						whileInView={{ opacity: 1, y: 0 }}
						viewport={{ once: true }}
						transition={{ duration: 0.8 }}
						className="group block font-anton leading-[0.9] text-[52px] sm:text-[110px] md:text-[160px] lg:text-[196px] hover:text-brand-red transition-colors"
					>
						(307) 222-4082
					</motion.a>
					<div className="mt-6 font-chivo text-sm sm:text-base font-bold uppercase tracking-widest text-white/70 flex items-center gap-3">
						<span className="w-2 h-2 bg-brand-red pulse-dot" />
						Answering live — right now.
					</div>
				</div>

				{/* Info grid */}
				<div className="grid grid-cols-1 md:grid-cols-3 gap-10 mt-14 sm:mt-20">
					<div>
						<div className="font-chivo text-[11px] uppercase tracking-[0.3em] font-bold text-brand-red mb-4">
							Hours
						</div>
						<div className="flex items-start gap-3">
							<Clock
								className="w-5 h-5 mt-1 text-white/70 flex-shrink-0"
								strokeWidth={2}
							/>
							<div>
								<div className="font-anton text-3xl sm:text-4xl leading-none">
									24 / 7 / 365
								</div>
								<div className="font-plex text-sm text-white/60 mt-2">
									We never close. Ever.
								</div>
							</div>
						</div>
					</div>

					<div>
						<div className="font-chivo text-[11px] uppercase tracking-[0.3em] font-bold text-brand-red mb-4">
							Headquarters
						</div>
						<div
							data-testid={FOOTER.address}
							className="flex items-start gap-3"
						>
							<MapPin
								className="w-5 h-5 mt-1 text-white/70 flex-shrink-0"
								strokeWidth={2}
							/>
							<div>
								<div className="font-chivo font-black text-lg leading-tight">
									30 N Gould St, Ste R
								</div>
								<div className="font-plex text-white/70 text-sm mt-1">
									Sheridan, WY 82801
								</div>
								<div className="font-plex text-white/50 text-xs mt-3">
									Dispatching nationwide, USA.
								</div>
							</div>
						</div>
					</div>

					<div>
						<div className="font-chivo text-[11px] uppercase tracking-[0.3em] font-bold text-brand-red mb-4">
							Management
						</div>
						<div className="flex items-start gap-3">
							<Building2
								className="w-5 h-5 mt-1 text-white/70 flex-shrink-0"
								strokeWidth={2}
							/>
							<div>
								<div className="font-chivo font-black text-lg">
									Managed by Truck Geeks LLC
								</div>
								<div className="font-plex text-white/60 text-sm mt-1">
									Licensed & insured operators nationwide.
								</div>
							</div>
						</div>
					</div>
				</div>

				{/* CTA bar */}
				<div className="mt-16 sm:mt-20 border-t border-white/15 pt-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
					<div className="font-plex text-xs sm:text-sm text-white/50">
						© {year} Breakdownexperts. All rights reserved.
					</div>
					<a
						href="tel:+13072224082"
						className="btn-red text-base sm:text-lg"
					>
						<Phone className="w-4 h-4" strokeWidth={2.5} />
						Call (307) 222-4082
					</a>
				</div>
			</div>
		</footer>
	);
};

export default Footer;
